import { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@supplier/meta";

const statementStatisticsRouter: RouteRecordRaw[] = [
    {
        path: "statementStatistics",
        name: "StatementStatistics",
        component: () => import("@/views/layouts/index.vue"),
        redirect: "/statementStatistics/project",
        meta: {
            title: "报表统计"
        },
        children: [
            {
                path: "/statementStatistics/project",
                name: "ProjectStatement",
                component: () => import("@/views/pages/statementStatistics/projectStatement/index.vue"),
                meta: {
                    title: "项目报表",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "/statementStatistics/fund",
                name: "FundStatement",
                component: () => import("@/views/pages/statementStatistics/fundStatement/index.vue"),
                meta: {
                    title: "资金报表",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "/statementStatistics/Logistics",
                name: "LogisticsStatement",
                component: () => import("@/views/pages/statementStatistics/logisticsStatement/index.vue"),
                meta: {
                    title: "物流报表",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "/statementStatistics/risk",
                name: "RiskStatement",
                component: () => import("@/views/pages/statementStatistics/riskStatement/index.vue"),
                meta: {
                    title: "风控报表",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "/statementStatistics/customer",
                name: "CustomerStatement",
                component: () => import("@/views/pages/statementStatistics/customerStatement/index.vue"),
                meta: {
                    title: "客户报表",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "/statementStatistics/stock",
                name: "StockStatement",
                meta: {
                    title: "库存报表"
                },
                redirect: "/statementStatistics/stock/reportPackage",
                children: [
                    {
                        path: "reportPackage",
                        name: "StockReportPackage",
                        component: () => import("@/views/pages/statementStatistics/stockStatement/reportPackage/index.vue"),
                        meta: {
                            title: "报表打包",
                            isNotShowHeader: true,
                            pageType: PAGE_TYPE.LIST.code,
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_PROJECT_R"
                                },
                                {
                                    label: "查看所有",
                                    value: "ROLE_PROJECT_ALL_R"
                                },
                                {
                                    label: "处理",
                                    value: "ROLE_PROJECT_DEAL"
                                }
                            ]
                        }
                    },
                    {
                        path: "coreLibrary",
                        name: "StockCoreLibrary",
                        component: () => import("@/views/pages/statementStatistics/stockStatement/coreLibrary/index.vue"),
                        meta: {
                            title: "核库报表",
                            isNotShowHeader: true,
                            pageType: PAGE_TYPE.LIST.code,
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_PROJECT_R"
                                },
                                {
                                    label: "查看所有",
                                    value: "ROLE_PROJECT_ALL_R"
                                },
                                {
                                    label: "处理",
                                    value: "ROLE_PROJECT_DEAL"
                                }
                            ]
                        }
                    },
                    {
                        path: "coreLibrary/detail/:id",
                        name: "StockCoreLibraryDetail",
                        component: () => import("@/views/pages/statementStatistics/stockStatement/coreLibrary/detail.vue"),
                        meta: {
                            title: "核库报表明细",
                            isNotShowHeader: true,
                            activeMenu: "StockCoreLibrary",
                            hidden: true,
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_PROJECT_R"
                                },
                                {
                                    label: "查看所有",
                                    value: "ROLE_PROJECT_ALL_R"
                                },
                                {
                                    label: "处理",
                                    value: "ROLE_PROJECT_DEAL"
                                }
                            ]
                        }
                    },
                    {
                        path: "inboundDetection",
                        name: "InboundDetection",
                        component: () => import("@/views/pages/statementStatistics/stockStatement/inboundDetection/index.vue"),
                        meta: {
                            title: "入库检测表",
                            isNotShowHeader: true,
                            pageType: PAGE_TYPE.LIST.code,
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_PROJECT_R"
                                },
                                {
                                    label: "查看所有",
                                    value: "ROLE_PROJECT_ALL_R"
                                },
                                {
                                    label: "处理",
                                    value: "ROLE_PROJECT_DEAL"
                                }
                            ]
                        }
                    },
                    {
                        path: "detailed",
                        name: "StockDetailed",
                        component: () => import("@/views/pages/statementStatistics/stockStatement/detailed/index.vue"),
                        meta: {
                            title: "库存明细",
                            isNotShowHeader: true,
                            pageType: PAGE_TYPE.LIST.code,
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_PROJECT_R"
                                },
                                {
                                    label: "查看所有",
                                    value: "ROLE_PROJECT_ALL_R"
                                },
                                {
                                    label: "处理",
                                    value: "ROLE_PROJECT_DEAL"
                                }
                            ]
                        }
                    },
                    {
                        path: "summary",
                        name: "StockSummary",
                        component: () => import("@/views/pages/statementStatistics/stockStatement/summary/index.vue"),
                        meta: {
                            title: "库存汇总",
                            isNotShowHeader: true,
                            pageType: PAGE_TYPE.LIST.code,
                            authOptions: [
                                {
                                    label: "查看",
                                    value: "ROLE_PROJECT_R"
                                },
                                {
                                    label: "查看所有",
                                    value: "ROLE_PROJECT_ALL_R"
                                },
                                {
                                    label: "处理",
                                    value: "ROLE_PROJECT_DEAL"
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    }
];

export default statementStatisticsRouter;
